module.exports = require("core-js-pure/stable/reflect/construct");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js-stable/reflect/construct.js
// module id = 494
// module chunks = 0 1